import { render, staticRenderFns } from "./corneal-photo.vue?vue&type=template&id=bdcfba4e&"
import script from "./corneal-photo.vue?vue&type=script&lang=js&"
export * from "./corneal-photo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports